<template>
    <div class="box is-height-fit">
        <PageHead title="Register" />

        <div class="box-title">
            Register
        </div>

        <div>
            <form @submit.prevent="handleSubmit" novalidate>
                <Field placeholder="First Name" v-model="form.firstName" :disabled="isLoading" :error="form.errors.firstName">
                    <template #iconLeft>
                        <Icon :icon="mdiBadgeAccountHorizontal" />
                    </template>
                </Field>

                <Field placeholder="Last Name" v-model="form.lastName" :disabled="isLoading" :error="form.errors.lastName">
                    <template #iconLeft>
                        <Icon :icon="mdiBadgeAccountHorizontal" />
                    </template>
                </Field>

                <Field placeholder="Email" type="email" v-model="form.email" :disabled="isLoading" :error="form.errors.email">
                    <template #iconLeft>
                        <Icon :icon="mdiEmail" />
                    </template>
                </Field>
                <Field placeholder="Password" type="password" v-model="form.password" :disabled="isLoading" :error="form.errors.password">
                    <template #iconLeft>
                        <Icon :icon="mdiLock" />
                    </template>
                </Field>
                <Field placeholder="Confirm Password" type="password" v-model="form.passwordConfirm" :disabled="isLoading" :error="form.errors.passwordConfirm">
                    <template #iconLeft>
                        <Icon :icon="mdiLockCheck" />
                    </template>
                </Field>

                <div class="is-flex is-align-items-center is-justify-content-flex-end">
                    <div>
                        <button type="submit" class="button is-primary" :class="{'is-loading': isLoading}">
                            <span class="icon is-small">
                                <Icon :icon="mdiClipboardAccount" />
                            </span>
                            <span>
                                Sign Up
                            </span>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import Field from '@/Components/common/Field.vue';
import { mdiEmail, mdiLock, mdiLockCheck, mdiClipboardAccount, mdiBadgeAccountHorizontal } from '@mdi/js'
import { useForm } from '@inertiajs/vue3';
import Icon from '@/Components/Icon.vue';
import Base from '@/Layouts/Base.vue';
import Default from '@/Layouts/Default.vue';
import PageHead from '@/Components/PageHead.vue';

defineOptions({
    layout: [Base, Default],
})

const isLoading = ref(false);

const form = useForm({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    passwordConfirm: '',
});

async function handleSubmit() {
    form.post(route('register'), {
        onStart: () => {
            isLoading.value = true;
        },

        onFinish: () => {
            isLoading.value = false;
        },
    });
}
</script>

<style lang="scss" scoped>
    @use 'bulma/sass/utilities/mixins';

    .box {
        max-width: 25rem;
        width: 100%;
    }

    @include mixins.mobile {
        .box {
            min-width: 100%;
            width: 100%;
        }
    }
</style>
